var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarsStreamline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17008 3.04808C7.45835 2.31714 8.49282 2.31714 8.78109 3.04809L9.67442 5.3132C9.76242 5.53636 9.93909 5.71301 10.1623 5.80102L12.4274 6.69437C13.1583 6.98264 13.1583 8.01711 12.4274 8.30539L10.1623 9.19871C9.93909 9.28671 9.76242 9.46338 9.67442 9.68654L8.78109 11.9517C8.49281 12.6826 7.45835 12.6826 7.17008 11.9517L6.27673 9.68654C6.18871 9.46338 6.01207 9.28671 5.78891 9.19871L3.52378 8.30539C2.79285 8.0171 2.79285 6.98264 3.52379 6.69437L5.78891 5.80102C6.01207 5.713 6.18872 5.53636 6.27673 5.3132L7.17008 3.04808Z",
    stroke: "#313131",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2159 11.1232C14.3684 10.7364 14.9159 10.7364 15.0684 11.1232L15.7356 12.8149C15.7822 12.9329 15.8757 13.0264 15.9937 13.073L17.6854 13.7402C18.0721 13.8927 18.0721 14.4402 17.6854 14.5927L15.9937 15.2599C15.8757 15.3064 15.7822 15.3999 15.7356 15.518L15.0684 17.2097C14.9159 17.5964 14.3684 17.5964 14.2159 17.2097L13.5487 15.518C13.5022 15.3999 13.4087 15.3064 13.2906 15.2599L11.5989 14.5927C11.2122 14.4402 11.2122 13.8927 11.5989 13.7402L13.2906 13.073C13.4087 13.0264 13.5022 12.9329 13.5487 12.8149L14.2159 11.1232Z",
    stroke: "#313131",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarsStreamline);
export default __webpack_public_path__ + "static/media/icon-stars-streamline.c4012952fa74a1a5484c5f88dc727d38.svg";
export { ForwardRef as ReactComponent };